import { combineReducers } from 'redux';
import { MatchesActions } from '../reducer';
import {
  CLEAR_CURRENT_MATCH_BETS,
  GET_BETS_BY_MATCH_0_BETS, GET_BETS_BY_MATCH_REQUEST,
  GET_BETS_BY_MATCH_SUCCESS,
} from '../../../constants/matches';
import { Markets } from '../../../types/BetMarkets';
import { transformToMarkets } from './transformer';

export type BetState = {
  markets: Markets;
  requested: boolean;
};

export const betsMatchesReducer = combineReducers<BetState, MatchesActions>({
  markets: (state: Markets = {}, action) => {
    switch (action.type) {
      case GET_BETS_BY_MATCH_0_BETS:
        return {};
      case GET_BETS_BY_MATCH_SUCCESS:
        return transformToMarkets(action.payload);
      case CLEAR_CURRENT_MATCH_BETS:
        return {};
      default:
        return state;
    }
  },
  requested: (state: boolean = false, action) => {
    switch (action.type) {
      case GET_BETS_BY_MATCH_REQUEST:
        return false;
      case GET_BETS_BY_MATCH_0_BETS:
        return true;
      case GET_BETS_BY_MATCH_SUCCESS:
        return true;
      case CLEAR_CURRENT_MATCH_BETS:
        return false;
      default:
        return state;
    }
  },
});
